import type { SVGProps } from 'react';
const SvgIconHamburgerMenuFilledSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} {...props}>
    <path
      fill="#3E704B"
      d="M3 6.071A1.07 1.07 0 0 1 4.071 5H21.93c.592 0 1.07.478 1.07 1.071a1.07 1.07 0 0 1-1.071 1.072H4.07A1.07 1.07 0 0 1 3 6.07zm0 7.143c0-.594.478-1.071 1.071-1.071H21.93c.593 0 1.071.477 1.071 1.071s-.478 1.072-1.071 1.072H4.07A1.07 1.07 0 0 1 3 13.214m20 7.143c0 .594-.478 1.071-1.071 1.071H4.07A1.07 1.07 0 0 1 3 20.357c0-.594.478-1.071 1.071-1.071H21.93c.593 0 1.071.477 1.071 1.071z"
    />
  </svg>
);
export default SvgIconHamburgerMenuFilledSmall;
